import { v4 as uuid } from 'uuid';

export function generateBlockID(): string {
  return uuid();
}
